export default __webpack_public_path__ + "static/media/raw-data.cbfc63c9.svg";